module.exports = __webpack_public_path__ + "9148cf179e02a58886307c371d11af3e.gif";